export const EU = 'eu'
export const NON_EU = 'non_eu'
